<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" rel="stylesheet">
<div style="padding-top: 40px;">
  <h4 class="center" style="color: green">{{resetMessage}}</h4>
	<div class="row" style="padding-right: 15%;padding-left:15% ;">
		<div *ngIf="emailScreen == 1 " class="col-md-12">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h3><i class="fa fa-lock fa-4x"></i></h3>
                  <h2 class="text-center">Forgot Password?</h2>
                  <p>You can reset your password here.</p>
                  <div class="panel-body">
                    <p>Enter your registered email id.</p>
                    <form [formGroup]="forgotPasswordForm" (ngSubmit)="otpScreen('form')" autocomplete="off" class="form" >
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                          <input formControlName="email" [(ngModel)]="emailVlaue" placeholder="Registered email address" class="form-control" type="email">
                          
                        </div>
                        <p style="color: red;">{{userNotFoundError}}</p>
                      </div>
                      <span class="form-text error"
                          *ngIf="forgotPasswordForm.controls.email.touched && forgotPasswordForm.controls.email.errors?.required">
                          Please Enter Valid Email
                      </span>
                      <div class="form-group">
                        <button type="submit" class="button" onclick="this.classList.toggle('button--loading')" [disabled]="forgotPasswordForm.invalid">
                          <span class="button__text">Reset Password</span>
                      </button>
                      </div>
                      
                      
                      <input type="hidden" class="hide" name="token" id="token" value=""> 
                    </form>
    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="emailScreen == 2" class="col-md-12">
           <mat-card>
             <mat-card-content>
                      <div class="card-body p-5 text-center">
                        <h4>Verify</h4>
                        <p>Your code was sent to you via email</p>
            
                        <form [formGroup]="otpForm">
                          <div class="otp-field mb-4">
                            <input type="number" formControlName="digit1" #digit1Input (input)="onDigitInput(1)" required />
                            <input type="number" formControlName="digit2" #digit2Input (input)="onDigitInput(2)" required />
                            <input type="number" formControlName="digit3" #digit3Input (input)="onDigitInput(3)" required />
                            <input type="number" formControlName="digit4" #digit4Input (input)="onDigitInput(4)" required />
                            <input type="number" formControlName="digit5" #digit5Input (input)="onDigitInput(5)" required />
                            <input type="number" formControlName="digit6" #digit6Input required />
                          </div>
                        <p style="color: red;">{{errorMsg}}</p>
                          <button class="verify-button mb-3" (click)="vrifyOtp()" [disabled]="otpForm.invalid">
                            Verify
                          </button>
                        </form>
                        
            
                        <p class="resend text-muted mb-0">
                          Didn't receive code? <b style="cursor: pointer;color: blue;" (click)="otpScreen('request')">Request again</b>
                        </p>
                      </div>
                    </mat-card-content>
                    </mat-card>
          </div>
          <div *ngIf="emailScreen == 3" class="col-md-12">
            <mat-card style="padding-right:10%;">
              <mat-card-content>
                <form [formGroup]="signupForm" (ngSubmit)="resetPassword()">
                  <h2 class="formTitle">
                    Change your password
                  </h2>
                  <label  class="fa fa-key icon">New Password</label>
                    <mat-form-field  appearance="outline">
                        <input matInput [type]="hide ? 'password' : 'text'" placeholder="Password"
                            formControlName="password" required>
                        <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>
                    <br>
                    <br>
                    <label  class="fa fa-key icon">Confirm Password</label>
                    <mat-form-field  appearance="outline">
                        <input matInput [type]="hide ? 'password' : 'text'" placeholder="Password"
                            formControlName="confirmPassword" required>
                        <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>
                    <div *ngIf="!signupForm.valid">
                      <p style="color: red;">Passwords do not match.</p>
                     </div>
                  <div class="buttonWrapper">
                    <button type="submit" id="submitButton" class="submitButton pure-button pure-button-primary" [disabled]="!signupForm.valid">
                      <span>Change Password</span>
                    </button>
                  </div>
                </form>
                
              </mat-card-content>
            </mat-card>
          </div>
          <div *ngIf="emailScreen == 4" class="col-md-12">
            
                <div class="success-message">
                  Password has been updated Successfully!
                  You Will be redirecting to login Page.
              </div>
             
          </div>
	</div>
</div>